import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { getPolicyEmail, getPolicyMailingAddress } from '../user-profile/selectors';
import {
  ProfileEditorsContainer,
  PolicyLabelMobile,
  PreferenceLabelMobile,
  PolicySummary,
  PolicyNumberLabel,
  PolicyMailingAddress,
  PolicyEmailAddress,
  ProfileRadioButtonContainer,
} from '../user-profile/styles';
import {
  GoPaperlessContainer,
  GoPaperlessPolicyPreferenceContainer,
  PreferenceRadioEmail,
  PreferenceRadioMail,
} from './styles';
import { getText } from '../../../utils/i18n';
import { useSnackbar } from 'notistack';
import { setPolicyPreference } from './policyDetailsReducer';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';

export const GoPaperless = (props) => {
  const { dispatch, i18n, isLoading, policies, policyPreference, policySystemId } = props;
  const { enqueueSnackbar } = useSnackbar();
  let policy = find(policies, ['policyRef', policySystemId]);
  useEffect(() => {
    dispatch(setPolicyPreference(policy.insured.preferredDeliveryMethod));
  }, []);
  const goPaperlessMissingEmailHelperText = getText(
    i18n,
    'policyDetails.helper.missingEmailText',
    'No email address found. Please add an email address to your policy if you wish to select paperless.',
  );
  return (
    <GoPaperlessContainer>
      <Link
        to={{
          pathname: '/customerInformation',
        }}
        state={{ prevPath: 'policyDetails' }}
      >
        {getText(
          i18n,
          'general.paperlessRedirect',
          'To change delivery preferences options please visit Customer Information by clicking here.',
        )}
      </Link>
      <br />
      <br />
      {policies.map((policy, index) => {
        return (
          policy.policyRef === policySystemId && (
            <GoPaperlessPolicyPreferenceContainer key={policy.policyRef}>
              <PolicySummary>
                <PolicyLabelMobile>Policy</PolicyLabelMobile>
                <PolicyNumberLabel
                  aria-label={`Policy Number ${policy.policyNumber} Status ${policy.statusCd}`}
                >
                  {policy.policyNumber + ' (' + policy.statusCd + ')'}
                </PolicyNumberLabel>
                <PolicyEmailAddress>
                  Email:{' '}
                  {getPolicyEmail(policy)
                    ? getPolicyEmail(policy)
                    : goPaperlessMissingEmailHelperText}
                </PolicyEmailAddress>
                <PolicyMailingAddress>
                  Address: {getPolicyMailingAddress(policy)}
                </PolicyMailingAddress>
              </PolicySummary>
              <ProfileEditorsContainer>
                <PreferenceLabelMobile>Preference</PreferenceLabelMobile>
                <ProfileRadioButtonContainer>
                  <PreferenceRadioEmail>
                    <label htmlFor="radioEmail">
                      <input
                        aria-label={`Preference for ${policy.policyNumber} Paperless`}
                        type="radio"
                        name={'deliveryPref_' + index}
                        value="Email"
                        id="radioEmail"
                        checked={policyPreference === 'Email'}
                        disabled={true}
                      />{' '}
                      Paperless
                    </label>
                  </PreferenceRadioEmail>
                  <PreferenceRadioMail>
                    <label htmlFor="radioBatch">
                      <input
                        aria-label={`Preference for ${policy.policyNumber} Mail`}
                        type="radio"
                        name={'deliveryPref_' + index}
                        value="Batch"
                        id="radioBatch"
                        checked={policyPreference === 'Batch'}
                        disabled={true}
                      />{' '}
                      Mail
                    </label>
                  </PreferenceRadioMail>
                </ProfileRadioButtonContainer>
              </ProfileEditorsContainer>
            </GoPaperlessPolicyPreferenceContainer>
          )
        );
      })}
    </GoPaperlessContainer>
  );
};

GoPaperless.propTypes = {
  dispatch: PropTypes.func,
  isLoading: PropTypes.bool,
  i18n: PropTypes.object,
  policies: PropTypes.array,
  policyNumber: PropTypes.string,
  policyPreference: PropTypes.string,
};

const mapStateToProps = (state) => ({
  i18n: state.i18nSlice.i18n,
  isLoading: state.profileSlice.isLoading,
  policies: state.policySlice.policies,
  policyPreference: state.policyDetailsSlice.policyPreference,
});

export default connect(mapStateToProps)(GoPaperless);
